export const cyberScoreTileOverviewGridClassName = 'grid grid-cols-2 items-start gap-3';

export const formatTrlBand = (trlBand: string): string => {
  const match = trlBand.match(/TRL_(\d+)_(\d+)/);

  if (match) {
    return `TRL ${match[1]}\u2013${match[2]}`;
  }

  return trlBand.replaceAll('_', ' ');
};
